// @ts-nocheck
/**
 *
 * @deprecated Use readImageDicomFileSeries from @itk-wasm/dicom instead
 */
const readImageDICOMArrayBufferSeries = async (arrayBuffers, options, fileNamesBackwardsCompatibility) => {
    throw new Error('readImageDICOMArrayBufferSeries is deprecated. Use readImageDicomFileSeries from @itk-wasm/dicom instead.');
};
export default readImageDICOMArrayBufferSeries;
//# sourceMappingURL=read-image-dicom-array-buffer-series.js.map